<script>
    import {minDialogHeight, maxDialogHeight} from "../../administration/user/data/variables";

    export default {
        name: "wizard-body",
        props: {
            minHeight: {
                type: Number,
                default: minDialogHeight
            },
            maxHeight: {
                type: Number,
                default: maxDialogHeight
            },
            height: Number,
        },
        computed: {
            style() {
                if (this.height) return `height: ${this.height}vh`;

                return `min-height: ${this.minHeight}vh; max-height: ${this.maxHeight}vh`;
            }
        }
    }
</script>

<template>
    <div class="mx-4 overflow-hidden" :style="style">
        <slot/>
    </div>
</template>

<style scoped>

</style>
